import React from "react";
import { ReactComponent as FrontendMentorIcon } from "../assets/icon-frontend-mentor.svg";
import { ReactComponent as GithubIcon } from "../assets/icon-github.svg";
import { ReactComponent as LinkedinIcon } from "../assets/icon-linkedin.svg";
import { ReactComponent as XIcon } from "../assets/xicon.svg";

export const Footer = () => {
  return (
    <div className="bg-primary-lightBlack w-screen flex flex-row align-center h-auto text-center pt-[3rem] pb-[5rem] ">
      <h3 className="text-primary-white w-full sm:ml-[2rem] md:ml-[7rem]">
        Dominyk McNamara
      </h3>
      <div className="flex flex-row w-full gap-4 mt-[1rem] sm:mt-0 lg:mr-[3rem] xl:mr-[5rem]">
        <a href="https://github.com/DominykMcNamara" target="#">
          <GithubIcon />{" "}
        </a>
        <a
          href="https://www.frontendmentor.io/profile/DominykMcNamara"
          target="#"
        >
          {" "}
          <FrontendMentorIcon />{" "}
        </a>
        <a
          href="https://www.linkedin.com/in/dominyk-smith-7b6a90248/"
          target="#"
        >
          {" "}
          <LinkedinIcon />{" "}
        </a>
        <a href="https://x.com/DominykMcNamara" target="#">
          <XIcon />{" "}
        </a>
        <h3 className="text-primary-white sm:ml-[2rem] md:ml-[7rem]">
          &copy; {new Date().getFullYear()} All Rights Reserved
        </h3>
      </div>
    </div>
  );
};
